export function formatTraceabilityNumber(value) {
  if (value == null || value === "") return "N/A";

  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) return "N/A";

    const normalized = trimmed.replace(/,/g, "");
    const number = Number(normalized);
    if (!Number.isFinite(number) || !/^-?\d+(\.\d+)?$/.test(normalized)) {
      return trimmed;
    }

    return normalized.includes(".") ? number.toFixed(2) : String(number);
  }

  if (typeof value === "number") {
    if (!Number.isFinite(value)) return "N/A";
    return Number.isInteger(value) ? String(value) : value.toFixed(2);
  }

  return String(value);
}

export function resolveUnitOfMeasureLabel(unitOfMeasure, fallbackLabel = null) {
  if (unitOfMeasure && typeof unitOfMeasure === "object") {
    return unitOfMeasure.label || unitOfMeasure.name || fallbackLabel || null;
  }

  if (fallbackLabel) {
    return fallbackLabel;
  }

  if (unitOfMeasure == null || unitOfMeasure === "") {
    return null;
  }

  const text = String(unitOfMeasure).trim();
  return /^\d+$/.test(text) ? null : text;
}

export function formatAmountWithUnit(
  value,
  unitOfMeasure,
  fallbackUnitLabel = null,
) {
  if (value == null || value === "") return "N/A";

  const formattedValue = formatTraceabilityNumber(value);
  const unitLabel = resolveUnitOfMeasureLabel(unitOfMeasure, fallbackUnitLabel);

  return unitLabel ? `${formattedValue} ${unitLabel}` : formattedValue;
}
